import { createElement, forwardRef } from 'react';
import gridNavImg from '../../assets/icon/grid-nav/right.png';
const ExampleComponent = (props, ref) => {
    const { columns, iconSize = 'medium', fontWeight = 'normal', fontSize = 12, fontColor = '#222', lineHeight = 'auto', lineNum = 1, dataSourceSetting } = props;
    console.log('dataSourceSetting的值为', dataSourceSetting);
    let iconStyle = {};
    switch (iconSize) {
        case 'large':
            iconStyle = { width: '64px', height: '64px' };
            break;
        case 'medium':
            iconStyle = { width: '48px', height: '48px' };
            break;
        case 'small':
            iconStyle = { width: '32px', height: '32px' };
            break;
        default:
            iconStyle = { width: '48px', height: '48px' };
    }
    const fontStyle = {
        fontWeight,
        fontSize,
        color: fontColor,
        lineHeight,
    };
    let fontLineStyle = {};
    fontLineStyle = {
        maxWidth: '80px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: lineNum,
        WebkitBoxOrient: 'vertical',
    };
    const fontAllStyle = { ...fontStyle, ...fontLineStyle };
    return (createElement("div", { ref: ref, className: "dc-grid-nav", style: { gridTemplateColumns: `repeat(${columns}, 1fr)` } }, dataSourceSetting.map((item, index) => item ? (createElement("a", { key: index, href: item.link || '#', className: "grid-item" },
        createElement("img", { src: item.icon ||
                'https://qcloudimg.tencent-cloud.cn/raw/fe54a986a821473655ba20afe30a543a.png', alt: item.title || '导航', style: iconStyle, className: "dc-grid-nav-item-img" }),
        createElement("span", { style: fontAllStyle, className: "dc-grid-nav-item-title" }, item.title || '无标题'),
        item.rightText ? (createElement("div", { className: "dc-grid-nav-item-right" },
            createElement("img", { src: gridNavImg, className: "dc-grid-nav-item-right-img" }),
            createElement("span", { className: "dc-grid-nav-item-right-title" }, item.rightText ?? '右侧'))) : '')) : null)));
};
const GridNav = forwardRef(ExampleComponent);
GridNav.displayName = 'GridNav';
export default GridNav;
